// extracted by mini-css-extract-plugin
module.exports =  {"Component":"Component-module__Component___j0ARh","hidden":"Component-module__hidden___hEGwQ","column":"Component-module__column___ZaEiT"};